export const SiteUrl = {
  WEB: 'https://mirai-kids-monte.com',
  CHAT_WEB: 'https://chat.mirai-kids-monte.com',
  LOCAL_CHAT: 'http://localhost:3003',
  LOCAL_WEB: 'http://localhost:3001',
} as const;

/** 相対パスを絶対URLに正規化。既に絶対URLならそのまま返す */
export function toAbsoluteUrl(path: string): string {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  return `${SiteUrl.WEB}${path.startsWith('/') ? '' : '/'}${path}`;
}
